// Version : 0.0.1
// Author : SATHISH
// LastEdit : SHIYAM
// MODFIED DATE: 26-09-2025
// Last ADD : Removed excel related code and added command lines

import PreCloseReportActionTypes from './preclose-loan-report.types';

/** ***************** GET PRECLOSE REPORT DETAILS START *********************** */
export const getPrecloseReportDetailsStart = (getData: any) => ({
	type: PreCloseReportActionTypes.GET_PRECLOSE_REPORT_LIST_START,
	payload: getData,
});

export const getPrecloseReportDetailsSuccess = (successData: any) => ({
	type: PreCloseReportActionTypes.GET_PRECLOSE_REPORT_LIST_SUCCESS,
	payload: successData,
});

export const getPrecloseReportDetailsFailure = (failureData: any) => ({
	type: PreCloseReportActionTypes.GET_PRECLOSE_REPORT_LIST_FAILURE,
	payload: failureData,
});

export const getPrecloseReportDetailsResponseResetStart = () => ({
	type: PreCloseReportActionTypes.GET_PRECLOSE_REPORT_LIST_RESPONSE_RESET,
});

export const getPrecloseReportDetailsResponseChanged = () => ({
	type: PreCloseReportActionTypes.GET_PRECLOSE_REPORT_LIST_RESPONSE_CHANGED,
});
/** ***************** GET PRECLOSE REPORT DETAILS END *********************** */
